import { dispatcher, api } from '@unicus/react-ui-kit';

export const OPENFINANCIALEXCHANGE = 'OPENFINANCIALEXCHANGE';

export const OPENFINANCIALEXCHANGE_FILE_IMPORT =
  'OPENFINANCIALEXCHANGE_FILE_IMPORT';
export const OPENFINANCIALEXCHANGE_FILE_IMPORT_FINISHED =
  'OPENFINANCIALEXCHANGE_FILE_IMPORT_FINISHED';

export const OPENFINANCIALEXCHANGE_TRANSACTIONS_QUERYPARAMS =
  'OPENFINANCIALEXCHANGE_TRANSACTIONS_QUERYPARAMS';

export const OPENFINANCIALEXCHANGE_TRANSACTIONS =
  'OPENFINANCIALEXCHANGE_TRANSACTIONS';
export const OPENFINANCIALEXCHANGE_TRANSACTIONS_FINISHED =
  'OPENFINANCIALEXCHANGE_TRANSACTIONS_FINISHED';

export const OPENFINANCIALEXCHANGE_UPDATE_TRANSACTION =
  'OPENFINANCIALEXCHANGE_UPDATE_TRANSACTION';

export const OPENFINANCIALEXCHANGE_CONCILIATIONS =
  'OPENFINANCIALEXCHANGE_CONCILIATIONS';
export const OPENFINANCIALEXCHANGE_CONCILIATIONS_FINISHED =
  'OPENFINANCIALEXCHANGE_CONCILIATIONS_FINISHED';

export const OPENFINANCIALEXCHANGE_CHANGE_CONCILIATION =
  'OPENFINANCIALEXCHANGE_CHANGE_CONCILIATION';
export const OPENFINANCIALEXCHANGE_CHANGE_CONCILIATION_FINISHED =
  'OPENFINANCIALEXCHANGE_CHANGE_CONCILIATION_FINISHED';

export const importFile = (file, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'openFinancialExchanges',
    actionType: OPENFINANCIALEXCHANGE_FILE_IMPORT,
    effect: async () => api.post(`open-financial-exchanges/import-file`, file),
    onSuccess,
    onFail: () => true
  });
};

export const setTransactionsQueryParams = (params) => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      OPENFINANCIALEXCHANGE_TRANSACTIONS_QUERYPARAMS,
      'openFinancialExchangeTransactions',
      params
    )
  );
};

export const transactionsFetch = (params = {}, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'openFinancialExchangeTransactions',
    actionType: OPENFINANCIALEXCHANGE_TRANSACTIONS,
    payload: params,
    effect: async () =>
      api.fetch(`open-financial-exchanges/transactions`, params),
    onSuccess,
    onFail: () => true
  });
};

export const conciliationsFetch = (params = {}, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'openFinancialExchangeConciliations',
    actionType: OPENFINANCIALEXCHANGE_CONCILIATIONS,
    payload: params,
    effect: async () =>
      api.fetch(`open-financial-exchanges/conciliations`, params),
    onSuccess,
    onFail: () => true
  });
};

export const changeTransaction = (data) => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      OPENFINANCIALEXCHANGE_UPDATE_TRANSACTION,
      'openFinancialExchangeTransactions',
      data
    )
  );
};

export const changeConciliation = (data = {}, onSuccess, onFail) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'openFinancialExchangeConciliations',
    actionType: OPENFINANCIALEXCHANGE_CHANGE_CONCILIATION,
    payload: data,
    effect: async () => api.put(`open-financial-exchanges/conciliations`, data),
    onSuccess,
    onFail
  });
};
